import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

const LINE = { hidden: { y: "110%", rotate: 2 }, show: { y: "0%", rotate: 0 } };

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0.15, inView = false }) => {
  const trigger = inView ? { whileInView: "show", viewport: { once: true, amount: 0.1 } } : { animate: "show" };
  return (
    <motion.span className={`block ${className}`} initial="hidden" {...trigger}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            variants={LINE}
            transition={{ duration: 1.1, ease: EASE, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const FadeUp = ({ children, delay = 0, className = "", as = "div", ...rest }) => {
  const Comp = motion[as];
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </Comp>
  );
};

export const Eyebrow = ({ children, className = "", dark = false }) => (
  <p className={`font-mono text-[11px] sm:text-xs uppercase tracking-[0.28em] flex items-center gap-3 ${dark ? "text-[#D9BD7E]" : "text-[#8A6A2B]"} ${className}`}>
    <span className={`h-px w-8 ${dark ? "bg-[#C5A059]" : "bg-[#8A6A2B]"}`} />
    {children}
  </p>
);

export { EASE };
